import React from 'react';
import {Menu, Transition} from '@headlessui/react';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {useCurrentScoreContractQuery} from 'api';
import ProspectScore from '../Task/ProspectScore';

type Option = {
  label: string;
  value: string;
  isUnselected: boolean;
};

const LeadFilters = () => {
  const {setFilterType} = useFilterModalContext();
  const {query} = useSearchParams();

  const {data: scoreContractData} = useCurrentScoreContractQuery();
  const hasScoreContract = scoreContractData?.currentScoreContract?.isActive;

  const options: Option[] = [
    ...(hasScoreContract
      ? [
          {
            label: '顧客スコア',
            value: 'prospectScore',
            isUnselected:
              !query?.prospectScore?.from &&
              !query?.prospectScore?.to &&
              (!query?.totalScoreRanks || query?.totalScoreRanks?.length === 0),
          },
        ]
      : []),
  ];

  const unselectedOptions = options.filter((option) => option.isUnselected);

  // Don't render the section if there are no available filters
  if (options.length === 0) {
    return null;
  }

  return (
    <div className="p-6 bg-white rounded flex items-start gap-4 min-h-[80px]">
      <div className="flex items-center gap-2 w-20">
        <h3 className="m-0 font-bold text-base">リード</h3>
      </div>
      <div className="flex-1 flex flex-col gap-4">
        <ProspectScore />
        {unselectedOptions.length > 0 && (
          <Menu as="div" className="relative text-left inline-block">
            <Menu.Button className="cursor-pointer bg-white border border-border rounded text-sm flex items-center justify-center h-7 px-4">
              + 検索条件を追加
            </Menu.Button>
            <Transition
              as={React.Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute left-0 border border-border w-[10rem] rounded bg-white shadow-lg focus:outline-none z-10">
                <div className="px-1 py-1 ">
                  {unselectedOptions.map((option, index) => (
                    <Menu.Item key={index}>
                      <button
                        onClick={() => setFilterType(option.value)}
                        className="cursor-pointer bg-white text-left p-2 w-full hover:bg-[#F1F8FF] hover:text-primary"
                      >
                        {option.label}
                      </button>
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        )}
      </div>
    </div>
  );
};

export default LeadFilters;
